<div class="login-body">
  <mat-card appearance="outlined" class="example-card">
    <mat-card-content>
      <form (ngSubmit)="onVerifyCode()" [formGroup]="codeForm">
        <div class="form-row">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Enter Secure Code</mat-label>
            <input formControlName="code" id="code" matInput name="code" type="text">
          </mat-form-field>
        </div>
        <div class="form-row-login-btn">
          <button class="loginBtn" color="primary" mat-raised-button type="submit" [disabled]="loading">
            <mat-progress-spinner *ngIf="loading" diameter="20" mode="indeterminate"></mat-progress-spinner>
            <span *ngIf="!loading">LOGIN</span>
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>
